module.exports = __webpack_public_path__ + "img/first_trophy.dbda80b3.svg";